import welcomeEN from '../locales/en/pages/welcome.json';
import welcomeDE from '../locales/de/pages/welcome.json';
import welcomeRU from '../locales/ru/pages/welcome.json';
import welcomeNL from '../locales/nl/pages/welcome.json';
import welcomeZH from '../locales/zh/pages/welcome.json';
import welcomeFI from '../locales/fi/pages/welcome.json';
import welcomeIT from '../locales/it/pages/welcome.json';

import webHostingEN from '../locales/en/pages/webHosting.json';
import webHostingDE from '../locales/de/pages/webHosting.json';
import webHostingRU from '../locales/ru/pages/webHosting.json';
import webHostingNL from '../locales/nl/pages/webHosting.json';
import webHostingZH from '../locales/zh/pages/webHosting.json';
import webHostingFI from '../locales/fi/pages/webHosting.json';
import webHostingIT from '../locales/it/pages/webHosting.json';

import vpsEN from '../locales/en/pages/vps.json';
import vpsDE from '../locales/de/pages/vps.json';
import vpsRU from '../locales/ru/pages/vps.json';
import vpsNL from '../locales/nl/pages/vps.json';
import vpsZH from '../locales/zh/pages/vps.json';
import vpsFI from '../locales/fi/pages/vps.json';
import vpsIT from '../locales/it/pages/vps.json';

import dedicatedServerEN from '../locales/en/pages/dedicatedServer.json';
import dedicatedServerDE from '../locales/de/pages/dedicatedServer.json';
import dedicatedServerRU from '../locales/ru/pages/dedicatedServer.json';
import dedicatedServerNL from '../locales/nl/pages/dedicatedServer.json';
import dedicatedServerZH from '../locales/zh/pages/dedicatedServer.json';
import dedicatedServerFI from '../locales/fi/pages/dedicatedServer.json';
import dedicatedServerIT from '../locales/it/pages/dedicatedServer.json';

import sitePagesEN from '../locales/en/pages/sitePages.json';
import sitePagesDE from '../locales/de/pages/sitePages.json';
import sitePagesRU from '../locales/ru/pages/sitePages.json';
import sitePagesNL from '../locales/nl/pages/sitePages.json';
import sitePagesZH from '../locales/zh/pages/sitePages.json';
import sitePagesFI from '../locales/fi/pages/sitePages.json';
import sitePagesIT from '../locales/it/pages/sitePages.json';

import ripeLirEN from '../locales/en/pages/ripeLir.json';
import ripeLirDE from '../locales/de/pages/ripeLir.json';
import ripeLirRU from '../locales/ru/pages/ripeLir.json';
import ripeLirNL from '../locales/nl/pages/ripeLir.json';
import ripeLirZH from '../locales/zh/pages/ripeLir.json';
import ripeLirFI from '../locales/fi/pages/ripeLir.json';
import ripeLirIT from '../locales/it/pages/ripeLir.json';

import ipTransitEN from '../locales/en/pages/ipTransit.json';
import ipTransitDE from '../locales/de/pages/ipTransit.json';
import ipTransitRU from '../locales/ru/pages/ipTransit.json';
import ipTransitNL from '../locales/nl/pages/ipTransit.json';
import ipTransitZH from '../locales/zh/pages/ipTransit.json';
import ipTransitFI from '../locales/fi/pages/ipTransit.json';
import ipTransitIT from '../locales/it/pages/ipTransit.json';

import colocationEN from '../locales/en/pages/colocation.json';
import colocationDE from '../locales/de/pages/colocation.json';
import colocationRU from '../locales/ru/pages/colocation.json';
import colocationNL from '../locales/nl/pages/colocation.json';
import colocationZH from '../locales/zh/pages/colocation.json';
import colocationFI from '../locales/fi/pages/colocation.json';
import colocationIT from '../locales/it/pages/colocation.json';

import cartEN from '../locales/en/pages/cart.json';
import cartDE from '../locales/de/pages/cart.json';
import cartRU from '../locales/ru/pages/cart.json';
import cartNL from '../locales/nl/pages/cart.json';
import cartZH from '../locales/zh/pages/cart.json';
import cartFI from '../locales/fi/pages/cart.json';
import cartIT from '../locales/it/pages/cart.json';

import reviewsEN from '../locales/en/pages/reviews.json';
import reviewsDE from '../locales/de/pages/reviews.json';
import reviewsRU from '../locales/ru/pages/reviews.json';
import reviewsNL from '../locales/nl/pages/reviews.json';
import reviewsZH from '../locales/zh/pages/reviews.json';
import reviewsFI from '../locales/fi/pages/reviews.json';
import reviewsIT from '../locales/it/pages/reviews.json';

import careersEN from '../locales/en/pages/careers.json';
import careersDE from '../locales/de/pages/careers.json';
import careersRU from '../locales/ru/pages/careers.json';
import careersNL from '../locales/nl/pages/careers.json';
import careersZH from '../locales/zh/pages/careers.json';
import careersFI from '../locales/fi/pages/careers.json';
import careersIT from '../locales/it/pages/careers.json';

import teamEN from '../locales/en/pages/team.json';
import teamDE from '../locales/de/pages/team.json';
import teamRU from '../locales/ru/pages/team.json';
import teamNL from '../locales/nl/pages/team.json';
import teamZH from '../locales/zh/pages/team.json';
import teamFI from '../locales/fi/pages/team.json';
import teamIT from '../locales/it/pages/team.json';

import paymentsEN from '../locales/en/pages/payments.json';
import paymentsDE from '../locales/de/pages/payments.json';
import paymentsRU from '../locales/ru/pages/payments.json';
import paymentsNL from '../locales/nl/pages/payments.json';
import paymentsZH from '../locales/zh/pages/payments.json';
import paymentsFI from '../locales/fi/pages/payments.json';
import paymentsIT from '../locales/it/pages/payments.json';

import partnersEN from '../locales/en/pages/partners.json';
import partnersDE from '../locales/de/pages/partners.json';
import partnersRU from '../locales/ru/pages/partners.json';
import partnersNL from '../locales/nl/pages/partners.json';
import partnersZH from '../locales/zh/pages/partners.json';
import partnersFI from '../locales/fi/pages/partners.json';
import partnersIT from '../locales/it/pages/partners.json';

import legalCommonEN from '../locales/en/pages/legalCommon.json';
import legalCommonDE from '../locales/de/pages/legalCommon.json';
import legalCommonRU from '../locales/ru/pages/legalCommon.json';
import legalCommonNL from '../locales/nl/pages/legalCommon.json';
import legalCommonZH from '../locales/zh/pages/legalCommon.json';
import legalCommonFI from '../locales/fi/pages/legalCommon.json';
import legalCommonIT from '../locales/it/pages/legalCommon.json';

import legalImprintEN from '../locales/en/pages/legalImprint.json';
import legalImprintDE from '../locales/de/pages/legalImprint.json';
import legalImprintRU from '../locales/ru/pages/legalImprint.json';
import legalImprintNL from '../locales/nl/pages/legalImprint.json';
import legalImprintZH from '../locales/zh/pages/legalImprint.json';
import legalImprintFI from '../locales/fi/pages/legalImprint.json';
import legalImprintIT from '../locales/it/pages/legalImprint.json';

import legalDsaEN from '../locales/en/pages/legalDsa.json';
import legalDsaDE from '../locales/de/pages/legalDsa.json';
import legalDsaRU from '../locales/ru/pages/legalDsa.json';
import legalDsaNL from '../locales/nl/pages/legalDsa.json';
import legalDsaZH from '../locales/zh/pages/legalDsa.json';
import legalDsaFI from '../locales/fi/pages/legalDsa.json';
import legalDsaIT from '../locales/it/pages/legalDsa.json';

import legalTcoEN from '../locales/en/pages/legalTco.json';
import legalTcoDE from '../locales/de/pages/legalTco.json';
import legalTcoRU from '../locales/ru/pages/legalTco.json';
import legalTcoNL from '../locales/nl/pages/legalTco.json';
import legalTcoZH from '../locales/zh/pages/legalTco.json';
import legalTcoFI from '../locales/fi/pages/legalTco.json';
import legalTcoIT from '../locales/it/pages/legalTco.json';

import legalFairUseEN from '../locales/en/pages/legalFairUse.json';
import legalFairUseDE from '../locales/de/pages/legalFairUse.json';
import legalFairUseRU from '../locales/ru/pages/legalFairUse.json';
import legalFairUseNL from '../locales/nl/pages/legalFairUse.json';
import legalFairUseZH from '../locales/zh/pages/legalFairUse.json';
import legalFairUseFI from '../locales/fi/pages/legalFairUse.json';
import legalFairUseIT from '../locales/it/pages/legalFairUse.json';

import legalRocEN from '../locales/en/pages/legalRoc.json';
import legalRocDE from '../locales/de/pages/legalRoc.json';
import legalRocRU from '../locales/ru/pages/legalRoc.json';
import legalRocNL from '../locales/nl/pages/legalRoc.json';
import legalRocZH from '../locales/zh/pages/legalRoc.json';
import legalRocFI from '../locales/fi/pages/legalRoc.json';
import legalRocIT from '../locales/it/pages/legalRoc.json';

import legalAgbEN from '../locales/en/pages/legalAgb.json';
import legalAgbDE from '../locales/de/pages/legalAgb.json';
import legalAgbRU from '../locales/ru/pages/legalAgb.json';
import legalAgbNL from '../locales/nl/pages/legalAgb.json';
import legalAgbZH from '../locales/zh/pages/legalAgb.json';
import legalAgbFI from '../locales/fi/pages/legalAgb.json';
import legalAgbIT from '../locales/it/pages/legalAgb.json';

import legalPrivacyEN from '../locales/en/pages/legalPrivacy.json';
import legalPrivacyDE from '../locales/de/pages/legalPrivacy.json';
import legalPrivacyRU from '../locales/ru/pages/legalPrivacy.json';
import legalPrivacyNL from '../locales/nl/pages/legalPrivacy.json';
import legalPrivacyZH from '../locales/zh/pages/legalPrivacy.json';
import legalPrivacyFI from '../locales/fi/pages/legalPrivacy.json';
import legalPrivacyIT from '../locales/it/pages/legalPrivacy.json';

import gameServerEN from '../locales/en/pages/gameServer.json';
import gameServerDE from '../locales/de/pages/gameServer.json';
import gameServerRU from '../locales/ru/pages/gameServer.json';
import gameServerNL from '../locales/nl/pages/gameServer.json';
import gameServerZH from '../locales/zh/pages/gameServer.json';
import gameServerFI from '../locales/fi/pages/gameServer.json';
import gameServerIT from '../locales/it/pages/gameServer.json';

import ddosProtectionEN from '../locales/en/pages/ddosProtection.json';
import ddosProtectionDE from '../locales/de/pages/ddosProtection.json';
import ddosProtectionRU from '../locales/ru/pages/ddosProtection.json';
import ddosProtectionNL from '../locales/nl/pages/ddosProtection.json';
import ddosProtectionZH from '../locales/zh/pages/ddosProtection.json';
import ddosProtectionFI from '../locales/fi/pages/ddosProtection.json';
import ddosProtectionIT from '../locales/it/pages/ddosProtection.json';

import lookingGlassEN from '../locales/en/pages/lookingGlass.json';
import lookingGlassDE from '../locales/de/pages/lookingGlass.json';
import lookingGlassRU from '../locales/ru/pages/lookingGlass.json';
import lookingGlassNL from '../locales/nl/pages/lookingGlass.json';
import lookingGlassZH from '../locales/zh/pages/lookingGlass.json';
import lookingGlassFI from '../locales/fi/pages/lookingGlass.json';
import lookingGlassIT from '../locales/it/pages/lookingGlass.json';

import uptimeEN from '../locales/en/pages/uptime.json';
import uptimeDE from '../locales/de/pages/uptime.json';
import uptimeRU from '../locales/ru/pages/uptime.json';
import uptimeNL from '../locales/nl/pages/uptime.json';
import uptimeZH from '../locales/zh/pages/uptime.json';
import uptimeFI from '../locales/fi/pages/uptime.json';
import uptimeIT from '../locales/it/pages/uptime.json';

import smokepingEN from '../locales/en/pages/smokeping.json';
import smokepingDE from '../locales/de/pages/smokeping.json';
import smokepingRU from '../locales/ru/pages/smokeping.json';
import smokepingNL from '../locales/nl/pages/smokeping.json';
import smokepingZH from '../locales/zh/pages/smokeping.json';
import smokepingFI from '../locales/fi/pages/smokeping.json';
import smokepingIT from '../locales/it/pages/smokeping.json';

import slaEN from '../locales/en/pages/sla.json';
import slaDE from '../locales/de/pages/sla.json';
import slaRU from '../locales/ru/pages/sla.json';
import slaNL from '../locales/nl/pages/sla.json';
import slaZH from '../locales/zh/pages/sla.json';
import slaFI from '../locales/fi/pages/sla.json';
import slaIT from '../locales/it/pages/sla.json';

import peeringEN from '../locales/en/pages/peering.json';
import peeringDE from '../locales/de/pages/peering.json';
import peeringRU from '../locales/ru/pages/peering.json';
import peeringNL from '../locales/nl/pages/peering.json';
import peeringZH from '../locales/zh/pages/peering.json';
import peeringFI from '../locales/fi/pages/peering.json';
import peeringIT from '../locales/it/pages/peering.json';

import dcHardwareEN from '../locales/en/pages/dcHardware.json';
import dcHardwareDE from '../locales/de/pages/dcHardware.json';
import dcHardwareRU from '../locales/ru/pages/dcHardware.json';
import dcHardwareNL from '../locales/nl/pages/dcHardware.json';
import dcHardwareZH from '../locales/zh/pages/dcHardware.json';
import dcHardwareFI from '../locales/fi/pages/dcHardware.json';
import dcHardwareIT from '../locales/it/pages/dcHardware.json';

import dcLocationEN from '../locales/en/pages/dcLocation.json';
import dcLocationDE from '../locales/de/pages/dcLocation.json';
import dcLocationRU from '../locales/ru/pages/dcLocation.json';
import dcLocationNL from '../locales/nl/pages/dcLocation.json';
import dcLocationZH from '../locales/zh/pages/dcLocation.json';
import dcLocationFI from '../locales/fi/pages/dcLocation.json';
import dcLocationIT from '../locales/it/pages/dcLocation.json';

import resellerApplyEN from '../locales/en/pages/resellerApply.json';
import resellerApplyDE from '../locales/de/pages/resellerApply.json';
import resellerApplyRU from '../locales/ru/pages/resellerApply.json';
import resellerApplyNL from '../locales/nl/pages/resellerApply.json';
import resellerApplyZH from '../locales/zh/pages/resellerApply.json';
import resellerApplyFI from '../locales/fi/pages/resellerApply.json';
import resellerApplyIT from '../locales/it/pages/resellerApply.json';

import managedHostingEN from '../locales/en/pages/managedHosting.json';
import managedHostingDE from '../locales/de/pages/managedHosting.json';
import managedHostingRU from '../locales/ru/pages/managedHosting.json';
import managedHostingNL from '../locales/nl/pages/managedHosting.json';
import managedHostingZH from '../locales/zh/pages/managedHosting.json';
import managedHostingFI from '../locales/fi/pages/managedHosting.json';
import managedHostingIT from '../locales/it/pages/managedHosting.json';

import remoteHandsEN from '../locales/en/pages/remoteHands.json';
import remoteHandsDE from '../locales/de/pages/remoteHands.json';
import remoteHandsRU from '../locales/ru/pages/remoteHands.json';
import remoteHandsNL from '../locales/nl/pages/remoteHands.json';
import remoteHandsZH from '../locales/zh/pages/remoteHands.json';
import remoteHandsFI from '../locales/fi/pages/remoteHands.json';
import remoteHandsIT from '../locales/it/pages/remoteHands.json';

const pageNamespaces = {
    welcome: {
        en: welcomeEN,
        de: welcomeDE,
        ru: welcomeRU,
        nl: welcomeNL,
        zh: welcomeZH,
        fi: welcomeFI,
        it: welcomeIT,
    },
    webHosting: {
        en: webHostingEN,
        de: webHostingDE,
        ru: webHostingRU,
        nl: webHostingNL,
        zh: webHostingZH,
        fi: webHostingFI,
        it: webHostingIT,
    },
    vps: {
        en: vpsEN,
        de: vpsDE,
        ru: vpsRU,
        nl: vpsNL,
        zh: vpsZH,
        fi: vpsFI,
        it: vpsIT,
    },
    dedicatedServer: {
        en: dedicatedServerEN,
        de: dedicatedServerDE,
        ru: dedicatedServerRU,
        nl: dedicatedServerNL,
        zh: dedicatedServerZH,
        fi: dedicatedServerFI,
        it: dedicatedServerIT,
    },
    sitePages: {
        en: sitePagesEN,
        de: sitePagesDE,
        ru: sitePagesRU,
        nl: sitePagesNL,
        zh: sitePagesZH,
        fi: sitePagesFI,
        it: sitePagesIT,
    },
    ripeLir: {
        en: ripeLirEN,
        de: ripeLirDE,
        ru: ripeLirRU,
        nl: ripeLirNL,
        zh: ripeLirZH,
        fi: ripeLirFI,
        it: ripeLirIT,
    },
    ipTransit: {
        en: ipTransitEN,
        de: ipTransitDE,
        ru: ipTransitRU,
        nl: ipTransitNL,
        zh: ipTransitZH,
        fi: ipTransitFI,
        it: ipTransitIT,
    },
    colocation: {
        en: colocationEN,
        de: colocationDE,
        ru: colocationRU,
        nl: colocationNL,
        zh: colocationZH,
        fi: colocationFI,
        it: colocationIT,
    },
    cart: {
        en: cartEN,
        de: cartDE,
        ru: cartRU,
        nl: cartNL,
        zh: cartZH,
        fi: cartFI,
        it: cartIT,
    },
    reviews: {
        en: reviewsEN,
        de: reviewsDE,
        ru: reviewsRU,
        nl: reviewsNL,
        zh: reviewsZH,
        fi: reviewsFI,
        it: reviewsIT,
    },
    careers: {
        en: careersEN,
        de: careersDE,
        ru: careersRU,
        nl: careersNL,
        zh: careersZH,
        fi: careersFI,
        it: careersIT,
    },
    team: {
        en: teamEN,
        de: teamDE,
        ru: teamRU,
        nl: teamNL,
        zh: teamZH,
        fi: teamFI,
        it: teamIT,
    },
    payments: {
        en: paymentsEN,
        de: paymentsDE,
        ru: paymentsRU,
        nl: paymentsNL,
        zh: paymentsZH,
        fi: paymentsFI,
        it: paymentsIT,
    },
    partners: {
        en: partnersEN,
        de: partnersDE,
        ru: partnersRU,
        nl: partnersNL,
        zh: partnersZH,
        fi: partnersFI,
        it: partnersIT,
    },
    legalCommon: {
        en: legalCommonEN,
        de: legalCommonDE,
        ru: legalCommonRU,
        nl: legalCommonNL,
        zh: legalCommonZH,
        fi: legalCommonFI,
        it: legalCommonIT,
    },
    legalImprint: {
        en: legalImprintEN,
        de: legalImprintDE,
        ru: legalImprintRU,
        nl: legalImprintNL,
        zh: legalImprintZH,
        fi: legalImprintFI,
        it: legalImprintIT,
    },
    legalDsa: {
        en: legalDsaEN,
        de: legalDsaDE,
        ru: legalDsaRU,
        nl: legalDsaNL,
        zh: legalDsaZH,
        fi: legalDsaFI,
        it: legalDsaIT,
    },
    legalTco: {
        en: legalTcoEN,
        de: legalTcoDE,
        ru: legalTcoRU,
        nl: legalTcoNL,
        zh: legalTcoZH,
        fi: legalTcoFI,
        it: legalTcoIT,
    },
    legalFairUse: {
        en: legalFairUseEN,
        de: legalFairUseDE,
        ru: legalFairUseRU,
        nl: legalFairUseNL,
        zh: legalFairUseZH,
        fi: legalFairUseFI,
        it: legalFairUseIT,
    },
    legalRoc: {
        en: legalRocEN,
        de: legalRocDE,
        ru: legalRocRU,
        nl: legalRocNL,
        zh: legalRocZH,
        fi: legalRocFI,
        it: legalRocIT,
    },
    legalAgb: {
        en: legalAgbEN,
        de: legalAgbDE,
        ru: legalAgbRU,
        nl: legalAgbNL,
        zh: legalAgbZH,
        fi: legalAgbFI,
        it: legalAgbIT,
    },
    legalPrivacy: {
        en: legalPrivacyEN,
        de: legalPrivacyDE,
        ru: legalPrivacyRU,
        nl: legalPrivacyNL,
        zh: legalPrivacyZH,
        fi: legalPrivacyFI,
        it: legalPrivacyIT,
    },
    gameServer: {
        en: gameServerEN,
        de: gameServerDE,
        ru: gameServerRU,
        nl: gameServerNL,
        zh: gameServerZH,
        fi: gameServerFI,
        it: gameServerIT,
    },
    ddosProtection: {
        en: ddosProtectionEN,
        de: ddosProtectionDE,
        ru: ddosProtectionRU,
        nl: ddosProtectionNL,
        zh: ddosProtectionZH,
        fi: ddosProtectionFI,
        it: ddosProtectionIT,
    },
    lookingGlass: {
        en: lookingGlassEN,
        de: lookingGlassDE,
        ru: lookingGlassRU,
        nl: lookingGlassNL,
        zh: lookingGlassZH,
        fi: lookingGlassFI,
        it: lookingGlassIT,
    },
    uptime: {
        en: uptimeEN,
        de: uptimeDE,
        ru: uptimeRU,
        nl: uptimeNL,
        zh: uptimeZH,
        fi: uptimeFI,
        it: uptimeIT,
    },
    smokeping: {
        en: smokepingEN,
        de: smokepingDE,
        ru: smokepingRU,
        nl: smokepingNL,
        zh: smokepingZH,
        fi: smokepingFI,
        it: smokepingIT,
    },
    sla: {
        en: slaEN,
        de: slaDE,
        ru: slaRU,
        nl: slaNL,
        zh: slaZH,
        fi: slaFI,
        it: slaIT,
    },
    peering: {
        en: peeringEN,
        de: peeringDE,
        ru: peeringRU,
        nl: peeringNL,
        zh: peeringZH,
        fi: peeringFI,
        it: peeringIT,
    },
    dcHardware: {
        en: dcHardwareEN,
        de: dcHardwareDE,
        ru: dcHardwareRU,
        nl: dcHardwareNL,
        zh: dcHardwareZH,
        fi: dcHardwareFI,
        it: dcHardwareIT,
    },
    dcLocation: {
        en: dcLocationEN,
        de: dcLocationDE,
        ru: dcLocationRU,
        nl: dcLocationNL,
        zh: dcLocationZH,
        fi: dcLocationFI,
        it: dcLocationIT,
    },
    resellerApply: {
        en: resellerApplyEN,
        de: resellerApplyDE,
        ru: resellerApplyRU,
        nl: resellerApplyNL,
        zh: resellerApplyZH,
        fi: resellerApplyFI,
        it: resellerApplyIT,
    },
    remoteHands: {
        en: remoteHandsEN,
        de: remoteHandsDE,
        ru: remoteHandsRU,
        nl: remoteHandsNL,
        zh: remoteHandsZH,
        fi: remoteHandsFI,
        it: remoteHandsIT,
    },
    managedHosting: {
        en: managedHostingEN,
        de: managedHostingDE,
        ru: managedHostingRU,
        nl: managedHostingNL,
        zh: managedHostingZH,
        fi: managedHostingFI,
        it: managedHostingIT,
    },
};

export function mergePageResources(baseResources) {
    const merged = { ...baseResources };

    Object.entries(pageNamespaces).forEach(([namespace, byLocale]) => {
        Object.entries(byLocale).forEach(([locale, content]) => {
            merged[locale] = {
                ...merged[locale],
                [namespace]: content,
            };
        });
    });

    return merged;
}
